
import './App.css';
import Electric from './components/Form/Electric';

function App() {
  return (
    <div className="App">
      <h1>State of Washington Electric Vehicle Population Data Registration form </h1>
      <br/>
<Electric/>
    </div>
  );
}

export default App;
